export default __webpack_public_path__ + "ad10e11c878febe8045e6d75377aceec.png";